/* KENT product page: sticky add-to-cart bar + "Naturally dyed" colour note.
   Both only read the page and press the theme's own controls, so variant
   selection, apps (back-in-stock, size guide) and the cart keep working. */
(function () {
  var form = document.querySelector('.product__info form.product__form, .product__info form[action*="/cart/add"]');
  var realBtn = form && form.querySelector('[data-add-to-cart]');

  /* ---------- sticky add-to-cart ---------- */
  var bar = document.querySelector('[data-kent-satc]');
  if (bar && realBtn && 'IntersectionObserver' in window) {
    var barBtn = bar.querySelector('[data-kent-satc-btn]');
    var priceEl = bar.querySelector('[data-kent-satc-price]');
    var variantEl = bar.querySelector('[data-kent-satc-variant]');
    var pagePrice = document.querySelector('.product__info [data-product-price]');

    function sync() {
      if (pagePrice && priceEl) priceEl.textContent = pagePrice.textContent.trim();
      var label = realBtn.querySelector('[data-add-to-cart-text]');
      barBtn.textContent = label ? label.textContent.trim() : realBtn.textContent.trim();
      barBtn.disabled = realBtn.disabled;
      var picked = [].slice.call(form.querySelectorAll('input.variant-input:checked')).map(function (i) { return i.value; });
      if (variantEl) variantEl.textContent = picked.join(' / ') + (picked.length ? ' ·' : '');
    }
    var visible = true, pastButton = false, footerInView = false;
    function place() { bar.hidden = visible || !pastButton || footerInView; }
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      pastButton = entries[0].boundingClientRect.top <= 0;
      place();
      sync();
    }).observe(realBtn);
    // slide away once the footer is on screen, so footer links are never covered
    var footer = document.querySelector('footer, .site-footer, [id*="shopify-section"][id*="footer"]');
    if (footer) {
      new IntersectionObserver(function (entries) {
        footerInView = entries[0].isIntersecting;
        place();
      }).observe(footer);
    }
    form.addEventListener('change', function () { setTimeout(sync, 50); });
    new MutationObserver(sync).observe(realBtn, { attributes: true, childList: true, subtree: true });
    barBtn.addEventListener('click', function () {
      if (realBtn.disabled) {
        realBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      realBtn.click();
    });
    sync();
  }

  /* ---------- "Naturally dyed" beside colour names ---------- */
  var cfgEl = document.querySelector('[data-kent-dye]');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var names = (cfg.names || []).map(function (n) { return n.trim().toLowerCase(); }).filter(Boolean);

  function isDyed(value) {
    var v = (value || '').toLowerCase();
    if (v.indexOf('natural dye') > -1) return true;
    var base = v.replace(/\(.*?\)/g, '').trim();
    return names.some(function (n) { return base === n || base.indexOf(n) === 0; });
  }
  function clean(value) {
    return (value || '').replace(/\s*\((natural dye|naturally dyed)\)\s*/i, '').trim();
  }
  function decorate() {
    document.querySelectorAll('.product__info .variant-label__value').forEach(function (el) {
      var current = el.textContent.trim();
      // the theme writes the raw option value; only react when it differs from what we last showed
      if (current === el.dataset.kentShown) return;
      var next = clean(current);
      el.dataset.kentShown = next;
      if (next !== current) el.textContent = next;
      var note = el.parentNode.querySelector('.kent-dye-note');
      if (isDyed(current)) {
        if (!note) {
          note = document.createElement('span');
          note.className = 'kent-dye-note';
          el.insertAdjacentElement('afterend', note);
        }
        note.textContent = cfg.label || 'Naturally dyed';
      } else if (note) {
        note.remove();
      }
    });
  }
  decorate();
  var pending = false;
  document.querySelectorAll('.product__info .variant-label__value').forEach(function (el) {
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; decorate(); });
    }).observe(el, { childList: true, characterData: true, subtree: true });
  });
})();

/* "Size guide" (SmartSize app) moves onto the same line as the "Size" label, right-aligned */
(function () {
  function place() {
    var guide = document.getElementById('sizefox-container');
    if (!guide) return false;
    if (guide.parentElement && guide.parentElement.classList.contains('kent-size-head')) return true;
    var label = null;
    document.querySelectorAll('.variant-wrapper--boxes .variant-label, .variant-wrapper .variant-label').forEach(function (l) {
      if (!label && /^\s*size/i.test(l.textContent)) label = l;
    });
    if (!label) return false;
    var head = document.createElement('div');
    head.className = 'kent-size-head';
    label.parentNode.insertBefore(head, label);
    head.appendChild(label);
    head.appendChild(guide);
    return true;
  }
  var tries = 0;
  (function wait() {
    if (!place() && tries++ < 60) setTimeout(wait, 250);
  })();
})();

